import { render, staticRenderFns } from "./WorkOrderDetails.vue?vue&type=template&id=1169e278&scoped=true&"
import script from "./WorkOrderDetails.vue?vue&type=script&lang=js&"
export * from "./WorkOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrderDetails.vue?vue&type=style&index=0&id=1169e278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1169e278",
  null
  
)

export default component.exports